(() => {
  const container = document.querySelector('#sit-i-contact');
  if (!container || document.documentElement.lang !== 'en') return;
  let loaded = false;
  const loadForm = () => {
    if (loaded) return;
    loaded = true;
    const embed = document.createElement('script');
    embed.src = 'https://kinamics.activehosted.com/f/embed.php?id=3';
    embed.charset = 'utf-8';
    embed.async = true;
    container.appendChild(embed);
  };
  window.sitiContactCaptchaReady = loadForm;
  const captcha = document.createElement('script');
  captcha.src = 'https://www.google.com/recaptcha/api.js?onload=sitiContactCaptchaReady&render=explicit&hl=en';
  captcha.async = true;
  captcha.onerror = loadForm;
  document.head.appendChild(captcha);
  window.setTimeout(loadForm, 8000);
})();
